<!-- <div class="wabtn" id="wabutton">
  <style> [wa-tooltip] { position: relative; cursor: default;  &:hover { &::before { content: attr(wa-tooltip); font-size: 16px; text-align: center; position: absolute; display: block; right: calc(0% - 100px); left: null; min-width: 200px; max-width: 200px; bottom: calc(100% + 40px); transform: translate(-50%); animation: fade-in 500ms ease; background: #00E785; border-radius: 4px; padding: 10px; color: #ffffff; z-index: 1; } } }  @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); } }  [wa-tooltip] {  }  @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }</style>
  <a wa-tooltip="We are available! Click here to chat" target="_blank" href="https://wa.me/27660497922?text=Hi!%20I'm%20interested%20in%20your%20services%20and%20would%20love%20to%20know%20more%20about%20it.%20Could%20you%20please%20send%20me%20more%20information?%20Thank%20you!" style=" cursor: pointer;height: 48px;width: auto;padding: 7px 7px 7px 7px;position: fixed !important;color: #fff;bottom: 30px;right: 30px;;display: flex;text-decoration: none;font-size: 18px;font-weight: 600;font-family: sans-serif;align-items: center;z-index: 999999999 !important;background-color: #00E785;box-shadow: 4px 5px 10px rgba(0, 0, 0, 0.4);border-radius: 100px;animation: pulse 2.5s ease infinite;">
    <svg width="34" height="34" style="padding: 5px;" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1024_354)"><path d="M23.8759 4.06939C21.4959 1.68839 18.3316 0.253548 14.9723 0.0320463C11.613 -0.189455 8.28774 0.817483 5.61565 2.86535C2.94357 4.91323 1.10682 7.86244 0.447451 11.1638C-0.21192 14.4652 0.351026 17.8937 2.03146 20.8109L0.0625 28.0004L7.42006 26.0712C9.45505 27.1794 11.7353 27.7601 14.0524 27.7602H14.0583C16.8029 27.7599 19.4859 26.946 21.768 25.4212C24.0502 23.8965 25.829 21.7294 26.8798 19.1939C27.9305 16.6583 28.206 13.8682 27.6713 11.1761C27.1367 8.48406 25.8159 6.01095 23.8759 4.06939ZM14.0583 25.4169H14.0538C11.988 25.417 9.96008 24.8617 8.1825 23.8091L7.7611 23.5593L3.3945 24.704L4.56014 20.448L4.28546 20.0117C2.92594 17.8454 2.32491 15.2886 2.57684 12.7434C2.82877 10.1982 3.91938 7.80894 5.67722 5.95113C7.43506 4.09332 9.76045 2.87235 12.2878 2.48017C14.8152 2.08799 17.4013 2.54684 19.6395 3.78457C21.8776 5.02231 23.641 6.96875 24.6524 9.3179C25.6638 11.6671 25.8659 14.2857 25.2268 16.7622C24.5877 19.2387 23.1438 21.4326 21.122 22.999C19.1001 24.5655 16.6151 25.4156 14.0575 25.4157L14.0583 25.4169Z" fill="#E0E0E0"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6291 7.98363C10.3723 7.41271 10.1019 7.40123 9.85771 7.39143C9.65779 7.38275 9.42903 7.38331 9.20083 7.38331C9.0271 7.3879 8.8562 7.42837 8.69887 7.5022C8.54154 7.57602 8.40119 7.68159 8.28663 7.81227C7.899 8.17929 7.59209 8.62305 7.38547 9.11526C7.17884 9.60747 7.07704 10.1373 7.08655 10.6711C7.08655 12.3578 8.31519 13.9877 8.48655 14.2164C8.65791 14.4452 10.8581 18.0169 14.3425 19.3908C17.2382 20.5327 17.8276 20.3056 18.4562 20.2485C19.0848 20.1913 20.4843 19.4194 20.7701 18.6189C21.056 17.8183 21.0557 17.1323 20.9701 16.989C20.8844 16.8456 20.6559 16.7605 20.3129 16.5889C19.9699 16.4172 18.2849 15.5879 17.9704 15.4736C17.656 15.3594 17.4275 15.3023 17.199 15.6455C16.9705 15.9888 16.3139 16.7602 16.1137 16.9895C15.9135 17.2189 15.7136 17.2471 15.3709 17.0758C14.3603 16.6729 13.4275 16.0972 12.6143 15.3745C11.8648 14.6818 11.2221 13.8819 10.7072 13.0007C10.5073 12.6579 10.6857 12.472 10.8579 12.3007C11.0119 12.1472 11.2006 11.9005 11.3722 11.7003C11.5129 11.5271 11.6282 11.3346 11.7147 11.1289C11.7603 11.0343 11.7817 10.9299 11.7768 10.825C11.7719 10.7201 11.7409 10.6182 11.6867 10.5283C11.6001 10.3566 10.9337 8.66151 10.6291 7.98363Z" fill="white"></path><path d="M23.7628 4.02445C21.4107 1.66917 18.2825 0.249336 14.9611 0.0294866C11.6397 -0.190363 8.35161 0.804769 5.70953 2.82947C3.06745 4.85417 1.25154 7.77034 0.600156 11.0346C-0.051233 14.299 0.506321 17.6888 2.16894 20.5724L0.222656 27.6808L7.49566 25.7737C9.50727 26.8692 11.7613 27.4432 14.0519 27.4434H14.0577C16.7711 27.4436 19.4235 26.6392 21.6798 25.1321C23.936 23.6249 25.6947 21.4825 26.7335 18.9759C27.7722 16.4693 28.0444 13.711 27.5157 11.0497C26.9869 8.38835 25.6809 5.94358 23.7628 4.02445ZM14.0577 25.1269H14.0547C12.0125 25.1271 10.0078 24.5782 8.25054 23.5377L7.8339 23.2907L3.51686 24.4222L4.66906 20.2143L4.39774 19.7831C3.05387 17.6415 2.4598 15.1141 2.70892 12.598C2.95804 10.082 4.03622 7.72013 5.77398 5.88366C7.51173 4.04719 9.81051 2.84028 12.3089 2.45266C14.8074 2.06505 17.3638 2.5187 19.5763 3.74232C21.7888 4.96593 23.5319 6.89011 24.5317 9.21238C25.5314 11.5346 25.7311 14.1233 25.0993 16.5714C24.4675 19.0195 23.0401 21.1883 21.0414 22.7367C19.0427 24.2851 16.5861 25.1254 14.0577 25.1255V25.1269Z" fill="white"></path></g><defs><clipPath id="clip0_1024_354"><rect width="27.8748" height="28" fill="white" transform="translate(0.0625)"></rect></clipPath></defs></svg>
    <span class="button-text"></span>
  </a>
</div> -->


<div class="wrapper">
  <div class="page-header page-header-small section-dark img-fluid mt-5"
    style="background-image: url('./assets/img/website_2/image_11_background.png')">
    <div class="content-center">
      <div class="container">

        <h2 class="pt-5 mt-5 font-weight-bold d-lg-block d-none" style="height: 250px; color: #184685;">PRACTICE
          MANAGEMENT SOFTWARE<br>
          FOR BETTER PATIENT OUTCOMES</h2>


        <h2 class="pt-5 mt-5 font-weight-bold mb-5 d-block d-lg-none" style="height: 250px; color: #184685;">PRACTICE
          MANAGEMENT SOFTWARE<br>
          FOR BETTER PATIENT OUTCOMES</h2>

        <button type="button" class="btn btn-sm btn-danger mb-0" [routerLink]="['/get-a-quote']"> Get A Quote
        </button>



      </div>
    </div>

  </div>
</div>

<div class="container mt-n1 justify-content-center"
  style="z-index: 900; position: absolute; left: 50%; transform: translateX(-50%);">
  <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


    <div class="col-lg-8 mt-lg-n2 mt-2">
      <label class="">&nbsp;</label>
      <button type="button" class="btn btn-sm bg-gradient-secondary w-100 mb-0"><i class="fa fa-angle-down"
          aria-hidden="true"></i> A Complete END-TO-END Solution for Healthcare Professionals <i
          class="fa fa-angle-down" aria-hidden="true"></i></button>
    </div>
  </div>
</div>

<div class="container z-5 ">
  <!-- <a type="button" class="float d-none d-lg-block">
    <i class="fa fa-angle-down" aria-hidden="true"></i> Scroll down for more info <i class="fa fa-angle-down"
      aria-hidden="true"></i>
  </a> -->

</div>




<div class="features-66">
  <div class="container">
    <div class="row ml-auto mr-auto">
      <div class="col-lg-12 mt-lg-n2 mt-2 ml-auto mr-auto ">
        <h3 class="title text-center font-weight-bold">Intelligent AI Solutions for Modern Practice and Healthcare
          Management</h3>

        <!-- 
        <p class="ml-auto mr-auto text-center"> Especially when you’re...
        </p>
        <br>


        <li class="font-weight-bold text-center">Wasting time on manual admin,</li>
        <li class="font-weight-bold text-center">Losing revenue from billing errors, and</li>
        <li class="font-weight-bold text-center">Frustrating staff and patients.</li>
        <br>
        <p class="text-center">
          You're left feeling overwhelmed and stuck managing chaos instead of leading care.
          That’s why eMD’s practice management software simplifies it all, giving you back control, clarity,
          and most importantly; more time to focus on what matters most: your patients.
        </p> -->


      </div>
    </div>
  </div>
</div>


<div class="features-66 mt-2 pt-2 pb-0 section-gray ml-auto mr-auto">
  <div class="container">
    <div class="row ml-auto mr-auto">
      <div class="col-lg-10 mt-lg-n2 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive" alt="" src="./assets/img/website_2/image_10.png">
      </div>
    </div>
  </div>
</div>


<div class="container mt-n1 justify-content-center"
  style="z-index: 1; position: absolute; left: 50%; transform: translateX(-50%);">
  <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


    <div class="col-lg-8 mt-lg-n2 mt-2">
      <label class="">&nbsp;</label>
      <button type="button" class="btn btn-sm btn-danger w-100 mb-0" [routerLink]="['/get-a-quote']"> Get A Quote
      </button>
    </div>
  </div>
</div>





<div class="testimonials-1 pt-5 pb-1 mb-5">
  <div class="container">
    <div class="row ml-auto mr-auto">
      <div class="col-lg-12 mt-lg-n2 ml-auto mr-auto ">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Client Success Stories</h2>
            <h5 class="description">Hear from healthcare professionals across South Africa who utilise eMD Technologies’
              Practice Management Software to run their practices effectively and efficiently, focusing on patient care.
            </h5>
          </div>
        </div>
        <div class="space-top"></div>
        <div class="row">
          <!-- Updated testimonial card template -->
          <div *ngFor="let item of Data; index as item_index" class="col-md-4">
            <div class="card card-testimonial h-100" (click)="openModal(item)"
              style="cursor: pointer; display: flex; flex-direction: column;">
              <div class="card-icon">
                <i class="fa fa-quote-right" aria-hidden="true"></i>
              </div>
              <div class="card-body" style="flex: 1; display: flex; flex-direction: column;">
                <p class="card-description" style="flex: 1;">
                  {{item.summary_text}}
                </p>
                <div class="card-footer" style="margin-top: auto;">
                  <h4 class="card-title">{{item.owner}}</h4>
                  <h6 class="card-category">{{item.title}}</h6>
                  <h6 class="card-category"><small>{{item.duration}}</small></h6>
                </div>
              </div>
            </div>
          </div>

          <!-- Testimonial Modal Template -->
          <ng-template #testimonialModal let-c="close" let-d="dismiss">
            <div class="modal-header" style="z-index: 99999;">
              <h4>{{selectedItem?.owner}}</h4>
              <h5 class="modal-title">{{selectedItem?.title}}</h5>
              <button type="button" class="close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <div class="testimonial-content" [innerHTML]="selectedItem?.full_text"></div>
            </div>
            <div class="modal-footer">
              <div class="divider"></div>
              <div class="right-side">
                <button type="button" class="btn btn-secondary btn-link" (click)="c('Close click')">Close</button>
              </div>
            </div>
          </ng-template>




        </div>
      </div>
    </div>

  </div>
</div>


<div class="features-66 pb-0 section-gray pb-1 pt-2 ">
  <div class="container">
    <div class="row ml-auto mr-auto">
      <div class="col-12 col-lg-4 ml-auto mr-auto">
        <img class=" img-fluid img-responsive rounded" alt="" src="./assets/img/website_2/image_3-1.png"
          style="height: 60px;">
      </div>
      <div class="col-12 col-lg-4 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive rounded" alt="" src="./assets/img/website_2/image_3-2.png"
          style="height: 60px;">
      </div>
      <div class="col-12 col-lg-4 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive rounded" alt="" src="./assets/img/website_2/image_3-3.png"
          style="height: 60px;">
      </div>
    </div>
  </div>
</div>



<app-block-lab-partners></app-block-lab-partners>


<app-block-steps></app-block-steps>

<app-block-pms></app-block-pms>

<app-packages></app-packages>